import {Unit} from './unit';

export class UnitIcon {
  public static unitChargeStatusIconClass(status: string): string {
    const baseClass = 'icon ';
    const statusClasses = {
      [Unit.CHARGE_STATUS_PERFECT]: 'charge-state-high',
      [Unit.CHARGE_STATUS_OK]: 'charge-state-middle',
      [Unit.CHARGE_STATUS_WARNING]: 'charge-state-middle_warning',
      [Unit.CHARGE_STATUS_ALARM]: 'charge-state-low'
    };
    return baseClass + (statusClasses[status] || '');
  }
}
